import type { GetAppSettingsQuery } from '#src/graphql/queries/app-settings';

import { useSuspenseQuery } from '@apollo/client/react';
import { createContext, useContext, type ReactNode } from 'react';

import { GET_APP_SETTINGS } from '#src/graphql/queries/app-settings';

export type AppSettingsContextValue = GetAppSettingsQuery['appSettings'];

const AppSettingsContext = createContext<AppSettingsContextValue | undefined>(
  undefined,
);

interface AppSettingsProviderProps {
  children: ReactNode;
}

export function AppSettingsProvider({ children }: AppSettingsProviderProps) {
  const { data } = useSuspenseQuery(GET_APP_SETTINGS, {
    fetchPolicy: 'cache-first',
  });

  return (
    <AppSettingsContext.Provider value={data.appSettings}>
      {children}
    </AppSettingsContext.Provider>
  );
}

export function useAppSettings(): AppSettingsContextValue {
  const value = useContext(AppSettingsContext);
  if (value === undefined) {
    throw new Error('useAppSettings must be used within AppSettingsProvider');
  }
  return value;
}
